export const userState = {
  user: null,
  authenticating: true
}

const userReducer = (state = userState, action) => {
  switch (action.type) {
    case 'AUTHORIZED':
      return { ...state, user: action.value, authenticating: false }
    case 'UNAUTHORIZED':
      return { ...state, authenticating: false }
  }
  return state
}

export default userReducer



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js